import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Avatar, CardHeader, Typography } from '@mui/material';
import { ReactFCC } from '../../interface/react';
import useAuth from '../../features/auth/useAuth';
import ThemeSwitcher from '../ThemeSwitcher/ThemeSwitcher';

interface ProfileBoxProps {
	onIconClick?: () => void;
}

const ProfileBox: ReactFCC<ProfileBoxProps> = ({ onIconClick }) => {
	const { user } = useAuth();
	const navigate = useNavigate();

	const displayName = user?.displayName || user?.email || 'User';
	const profileImage = user?.photoURL || user?.displayName || '';

	const onMenuItemClickHandler = (path: string) => {
		navigate(path);
		onIconClick?.();
	};

	return (
		<CardHeader
			avatar={
				<Avatar
					alt={displayName}
					sx={{ width: 48, height: 48, cursor: 'pointer' }}
					onClick={() => onMenuItemClickHandler('/me')}
					src={profileImage}
				/>
			}
			title={<Typography variant="subtitle2">{displayName}</Typography>}
			subheader={<Typography variant="caption">{user?.email}</Typography>}
			action={<ThemeSwitcher />}
		/>
	);
};

export default ProfileBox;
